import { gql } from 'urql';

// TODO: POTOM FINALNE ZKONTROLOVAT, ZE QUERIES JSOU FAKT PRO BOOKERA -> TZN ABY DOSTAL DATA, TAK MUSI BEJT PRIHLASENEJ
// QUERIES

const baseRequestBookerFragment = gql`
	fragment BaseRequestBookerFragment on Request {
		id
		artist {
			id
			name
			url
			vat_invoicing
			rider_link
		}
		confirmed
		confirmed_name
		confirmed_phone
		confirmed_email
		steps_done

		main_email

		event_name
		event_date
		event_address_place
		event_address_street
		event_address_city
		event_address_zip
		event_address_gps

		promoter_name
		promoter_email
		promoter_phone

		contract_ico
		contract_address_street
		contract_address_city
		contract_address_zip
		contract_name

		tech_sound_name
		tech_sound_email
		tech_sound_phone

		tech_contact_name
		tech_contact_email
		tech_contact_phone

		time_arrival
		time_podium_access
		time_sound_test
		time_dinner
		time_hall_opening
		time_performance

		fee_type
		fee_amount
		fee_travel
		fee_total
		fee_other
		fee_vat
		fee_payment_type
		fee_paying_name
		fee_paying_email

		accomodation
		accomodation_type
		accomodation_name
		accomodation_street
		accomodation_city
		accomodation_zip
		accomodation_gps
		accomodation_event_distance
		accomodation_web
		accomodation_phone
		accomodation_check_in
		accomodation_check_out
		accomodation_breakfast
		accomodation_internet_access

		tech_update_at
		time_update_at
		accomodation_update_at
		exported_at
		notified_at

		isCompleted

		link_invoice
		link_contract

		prefilled
	}
`;

// const baseRequestPropertyFragment = gql`
// 	fragment BaseRequestPropertyFragment on RequestProperty {
// 		id
// 		organization_id
// 		required
// 		name
// 		label
// 		type
// 	}
// `;

export const QUERY_BOOKER_ORGANIZATION = gql`
	query Organization {
		organization {
			name
			logo
			url
			email
		}
	}
`;

export const QUERY_BOOKER_ORGANIZATION_EMAILS = gql`
	query OrganizationEmails {
		organizationEmails {
			id
			type
			email
		}
	}
`;

export const QUERY_REQUEST_COUNTS = gql`
	query RequestCounts($filter: FilterRequestInput) {
		requestCounts(filter: $filter) {
			confirmed
			completed
			incompleted
			exported
			nonExported
			past
			nonConfirmed
		}
	}
`;

export const QUERY_BOOKER_REQUESTS = gql`
	query Requests($type: RequestType, $filter: FilterRequestInput) {

		requests(type: $type, filter: $filter) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const QUERY_BOOKER_REQUEST = gql`
	query BookerRequest($url: String) {
		request(url: $url) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const QUERY_BOOKER_REQUEST_DATA = gql`
	query requestDetail($url: String) {
		requestDetail(url: $url) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const QUERY_BOOKER_ARTIST = gql`
	query Artist($id: ID) {
		artist(id: $id) {
			id
			name
			url
			organization_id
			vat_invoicing
			rider_link
		}
	}
`;

export const QUERY_BOOKER_ARTISTS = gql`
	query BookerArtists {
		bookerArtists {
			id
			name
			url
			organization_id
			vat_invoicing
			rider_link
		}
	}
`;

// -- NEXT VERSION

// export const QUERY_BOOKER_REQUEST_PROPERTIES = gql`
// 	query BookerRequestProperties {
// 		requestProperties {
// 			...BaseRequestPropertyFragment
// 		}

// 		${baseRequestPropertyFragment}
// 	}
// `;

// MUTATIONS

export const MUTATION_UPSERT_ARTIST = gql`
	mutation UpsertArtist($id: ID, $input: ArtistInput!) {
		upsertArtist(id: $id, input: $input) {
			id
			name
			url
			organization_id
			vat_invoicing
			rider_link
		}
	}
`;

export const MUTATION_UPSERT_ORGANIZATION_EMAIL = gql`
	mutation UpsertOrganizationEmail($id: ID, $input: OrganizationEmailInput!) {
		upsertOrganizationEmail(id: $id, input: $input) {
			id
			type
			email
		}
	}
`;

export const MUTATION_DELETE_ORGANIZATION_EMAIL = gql`
	mutation DeleteOrganizationEmail($id: ID) {
		deleteOrganizationEmail(id: $id) {
			id
			type
			email
		}
	}
`;

export const MUTATION_UPDATE_ORGANIZATION_PRIMARY_EMAIL = gql`
	mutation UpdateOrganizationPrimaryEmail($email: String) {
		updateOrganizationPrimaryEmail(email: $email) {
			name
			logo
			url
			email
		}
	}
`;

export const MUTATION_BOOKER_UPDATE_PASSWORD = gql`
	mutation UpdatePassword($input: UpdatePassword!) {
		updatePassword(input: $input) {
			status
			message
		}
	}
`;

export const MUTATION_UPDATE_PROFILE = gql`
	mutation UpdateProfile($input: UpdateProfileInput!) {
		updateProfile(input: $input) {
			status
			message
			currentUser {
				id
				name
				email
			}
		}
	}
`;

export const MUTATION_UPSERT_REQUEST_PROPERTY_VALUE = gql`
	mutation UpsertRequestPropertyValue($id: ID, $name: String, $value: String) {
		upsertRequestPropertyValue(id: $id, name: $name, value: $value) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const MUTATION_UPSERT_REQUEST = gql`
	mutation UpsertRequest($id: ID, $input: RequestInput!) {
		upsertRequest(id: $id, input: $input) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const MUTATION_UPDATE_EXPORTED = gql`
	mutation UpdateExported($id: ID) {
		updateExported(id: $id) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

export const MUTATION_URGENT_REQUEST = gql`
	mutation UrgentRequest($id: ID) {
		urgentRequest(id: $id) {
			...BaseRequestBookerFragment
		}

		${baseRequestBookerFragment}
	}
`;

// -- NEXT VERSION

// export const MUTATION_UPSERT_REQUEST_PROPERTY = gql`
// 	mutation UpsertRequestProperty($id: ID, $input: RequestPropertyInput!) {
// 		upsertRequestProperty(id: $id, input: $input) {
// 			...BaseRequestPropertyFragment
// 		}

// 		${baseRequestPropertyFragment}
// 	}
// `;
